/* eslint-disable camelcase,no-undef */
// Assign the asset host at runtime so our asset paths are relative and portable
if (typeof window !== 'undefined' && window.ASSET_HOST !== undefined) {
  __webpack_public_path__ = `${window.ASSET_HOST}/assets/packs/${__webpack_public_path__}`;
}

export default function getCdnHost() {
  if (typeof window !== 'undefined' && window.ASSET_HOST !== undefined) {
    return window.ASSET_HOST;
  }
  return '';
}
